import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { MatChipInputEvent, MatAutocompleteSelectedEvent } from '@angular/material';

@Component({
  selector: 'app-auto-complete-chips',
  templateUrl: './auto-complete-chips.component.html',
  styleUrls: ['./auto-complete-chips.component.scss']
})
export class AutoCompleteChipsComponent implements OnInit {
  @Input('data')
  set setData(data: any[]) {
    this.data = data;
    this.filter(this.searchString);
  }
  @Input('selectedData') selectedDataItems: any[];
  @Input('isItemSelected') isItemSelectedCallback: (selectedData: any[], item: any) => boolean;
  @Input('displayWith') displayWithCallback: ((value: any) => string) | null = null;
  @Input('idProperty') idProperty: string = 'id';
  @Input('displayProperty') displayProperty: string = 'name';
  @Input('allowMultiSelect') allowMultiSelect = false;
  @Input('disabled') disabled = false;
  @Input('fullWidth') fullWidth = true;
  @Input('class') class: string = '';
  @Input('showSelectedItem') showSelectedItem: boolean = false;
  @Input('parentRef') parentRef;
  @Output('selectedDataChanged') selectedDataChanged = new EventEmitter<any[]>();
  @Output('searchStringChanged') searchStringChanged = new EventEmitter<string>();
  data: any[];
  filteredData: any[] = [];
  selectedData: any[] = [];
  optionSelected = false;
  searchString = '';
  constructor() {}

  ngOnInit() {
    if (!this.isItemSelectedCallback) {
      this.isItemSelectedCallback = this.getIsItemSelected;
    } else {
      if (this.parentRef) {
        this.isItemSelectedCallback = this.isItemSelectedCallback.bind(this.parentRef);
      }
    }

    if (this.displayWithCallback && this.parentRef) {
      this.displayWithCallback = this.displayWithCallback.bind(this.parentRef);
    }

    if (this.selectedDataItems) {
      this.selectedData = this.selectedDataItems;
    }
    this.filteredData = this.filter(null);
  }

  addFromInput(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    this.filterData(value);

    if (input) input.value = '';

    this.searchStringChanged.emit('');
    this.searchString = '';
  }

  filterData(value) {
    if ((value || '').trim()) {
      let matchItems;
      if (this.data) matchItems = this.data.filter(x => this.isItemMatchKeyword(x, value));

      if (
        matchItems &&
        matchItems.length > 0 &&
        !this.optionSelected &&
        (this.allowMultiSelect || !this.isItemSelectedCallback(this.selectedData, matchItems[0]))
      ) {
        this.selectedData.push(matchItems[0]);
        this.selectedDataChanged.emit(this.selectedData);
        this.filteredData = this.filter(null);
      }
    }
  }

  addFromAutocomplete(event: MatAutocompleteSelectedEvent): void {
    this.selectedData.push(event.option.value);
    this.selectedDataChanged.emit(this.selectedData);
    this.filteredData = this.filter(null);
  }

  remove(item): void {
    if (this.disabled) return;

    const index = this.selectedData.indexOf(item);
    if (index >= 0) {
      this.selectedData.splice(index, 1);
      this.selectedDataChanged.emit(this.selectedData);
      this.filteredData = this.filter(null);
    }
  }

  inputChanged(event) {
    this.searchStringChanged.emit(event.target.value);
    this.searchString = event.target.value;
    this.filteredData = this.filter(event.target.value);
  }

  filter(searchKeyword: string): any[] {
    if (!this.data) return [];

    let filteredData = this.data.filter(x => this.isItemMatchKeyword(x, searchKeyword));

    if (!this.allowMultiSelect && !this.showSelectedItem && this.isItemSelectedCallback)
      filteredData = filteredData.filter(x => !this.isItemSelectedCallback(this.selectedData, x));

    return filteredData;
  }

  isItemMatchKeyword(item: any, searchKeyword: string): boolean {
    if (!searchKeyword) return true;

    const value = this.getItemTitle(item);

    if (!value) return false;

    return value.toLowerCase().includes(searchKeyword.toLowerCase());
  }

  getIsItemSelected(selectedData: any[], item: any): boolean {
    if (!item) return false;

    if (typeof item === 'string') return selectedData.filter(x => x === item).length > 0;

    if (item.hasOwnProperty(this.idProperty)) return selectedData.filter(x => x[this.idProperty] === item[this.idProperty]).length > 0;

    return false;
  }

  getItemTitle(item): string {
    if (this.displayWithCallback) return this.displayWithCallback(item);

    if (typeof item === 'string') return item;

    if (item.hasOwnProperty(this.displayProperty)) return item[this.displayProperty];

    return '';
  }
}
